// extracted by mini-css-extract-plugin
export default {"feedsContainer":"rKeMaaS3mrwsxM6ormd5"};